var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.content)?_c('span',{staticClass:"tooltip app-tooltip",class:( _obj = {}, _obj[("text-" + _vm.color)] = true, _obj ),attrs:{"data-tooltip":_vm.content}},[_c('open-icon',{attrs:{"glyph":_vm.glyph}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }